/**
 * ****************************************************************************
 * @description     :   Store
 * @created at      :   2024/06/06
 * @created by      :   hainn – hainn@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

import repository from './repository';

export default {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {
        fetchHelpCategories() {
            return repository
                .getHelpCategories()
                .then((res) => {
                    if (res.data.Code === 200) {
                        // Transform API data to the format expected by the component
                        const transformedData = res.data.Data.map((item) => ({
                            id: item.faq_id,
                            title: item.display_message,
                            description: item.message_content || '',
                            route: {
                                name: 'FaqCategories',
                                params: { faq_id: item.faq_id }
                            }
                        }));

                        return transformedData;
                    } else {
                        return [];
                    }
                })
                .catch((error) => {
                    console.log(error);
                    return [];
                })
                .finally(() => {});
        }
    }
};
